// <s-recently-viewed> remembers products a shopper opened (on this device) and shows them as a swipeable row.
// The current product is saved from data-* attributes; cards are built with DOM APIs (no HTML from storage).
const KEY = "lachi-recently-viewed";
const MAX = 10;

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    const current = {
      handle: this.dataset.handle,
      url: this.dataset.url,
      title: this.dataset.title,
      image: this.dataset.image,
      price: this.dataset.price,
    };
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem(KEY) || "[]");
      if (!Array.isArray(list)) list = [];
    } catch {
      list = [];
    }
    const others = list.filter((item) => item && item.handle && item.handle !== current.handle);
    this.#render(others.slice(0, 8));
    if (current.handle) {
      try {
        localStorage.setItem(KEY, JSON.stringify([current, ...others].slice(0, MAX)));
      } catch {}
    }
  }

  #render(items) {
    const track = this.querySelector("[data-rv-track]");
    if (!track || items.length === 0) return;
    for (const item of items) {
      const link = document.createElement("a");
      link.href = item.url;
      link.className = "flex w-[38%] shrink-0 snap-start flex-col gap-1.5 md:w-[calc(25%-0.75rem)]";
      const frame = document.createElement("div");
      frame.className = "aspect-[2/3] overflow-hidden rounded-card bg-surface-secondary";
      if (item.image) {
        const img = document.createElement("img");
        img.src = item.image;
        img.alt = item.title || "";
        img.loading = "lazy";
        img.className = "size-full object-cover object-top";
        frame.append(img);
      }
      const title = document.createElement("span");
      title.className = "line-clamp-2 text-sm font-medium text-on-surface";
      title.textContent = item.title || "";
      const price = document.createElement("span");
      price.className = "text-sm font-medium text-sale";
      price.textContent = item.price || "";
      link.append(frame, title, price);
      track.append(link);
    }
    this.hidden = false;
  }
}

if (!customElements.get("s-recently-viewed")) customElements.define("s-recently-viewed", RecentlyViewed);
